/**
 * A normal invoice prints the server PDF (#1684) so paper and email stay
 * byte-identical. A consolidated invoice prints in the browser: one summary
 * page, then one attachment page per work order (#3933).
 */
import { printHtmlWindow, type PrintHtmlResult } from '@/lib/printWindow';
import {
  buildConsolidatedInvoicePrintHtml,
  toConsolidatedPrintDocument,
  type ConsolidatedPrintDocument,
  type ConsolidatedPrintLabels,
  type ConsolidatedPrintSourceLine,
} from './consolidation/consolidatedInvoicePrint';

export { printInvoicePdf as printInvoice } from '@/hooks/useInvoices';

export { buildConsolidatedInvoicePrintHtml, toConsolidatedPrintDocument };

export type {
  ConsolidatedPrintDocument,
  ConsolidatedPrintLabels,
  ConsolidatedPrintSourceLine,
};

export function printConsolidatedInvoice(
  document: ConsolidatedPrintDocument,
): Promise<PrintHtmlResult> {
  return printHtmlWindow(buildConsolidatedInvoicePrintHtml(document));
}
